import React from 'react'


import { Badge } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { shape, string, arrayOf } from 'prop-types'

import i18n from 'Pods/Shared/I18n'

import cgLogo from 'images/cg_icon_rgb.svg'
import moLogo from 'images/modelry_icon_rgb.svg'

import { EMPTY_ARRAY } from 'Utils/stableDefaults'

const growYourSalesLinks = (locale) => {
  const sellMore = i18n.t('navigation.navbar.grow_your_sales.sell_more', { ns: 'rails', lng: locale })
  const marketInsights = i18n.t('navigation.navbar.grow_your_sales.3d_market_insights', { ns: 'rails', lng: locale })
  const topModelSearches = i18n.t('navigation.navbar.grow_your_sales.top_model_searches', { ns: 'rails', lng: locale })
  const topPrintSearches = i18n.t('navigation.navbar.grow_your_sales.top_print_searches', { ns: 'rails', lng: locale })

  return [
    {
      title: sellMore,
      href: '/discover/sell-more',
      trackLabel: 'For Designers',
      trackText: 'Sell More',
    },
    {
      title: marketInsights,
      href: '/discover/3d-market-trends',
      trackLabel: 'For Designers',
      trackText: 'Market Insights',
    },
    {
      title: topModelSearches,
      href: '/discover/3d-models-top-searches',
      trackLabel: 'For Designers',
      trackText: 'Top Model Searches',
    },
    {
      title: topPrintSearches,
      href: '/discover/3d-print-models-top-searches',
      trackLabel: 'For Designers',
      trackText: 'Top Print Searches',
    },
  ]
}

function CommunityDropdown({ communityLinks = EMPTY_ARRAY, locale = 'en' }) {
  const communityTitle = i18n.t('navigation.navbar.community.title', { ns: 'rails', lng: locale })
  const earnWithCgtraderTitle = i18n.t('navigation.navbar.community.earn_with_cgtrader', { ns: 'rails', lng: locale })
  const growYourSalesTitle = i18n.t('navigation.navbar.grow_your_sales.title', { ns: 'rails', lng: locale })
  const freelanceOnCgtrader = i18n.t('navigation.navbar.community.freelance_on_cgtrader', { ns: 'rails', lng: locale })
  const workOnModelry = i18n.t('navigation.navbar.community.work_on_modelry', { ns: 'rails', lng: locale })
  const salesLinks = growYourSalesLinks(locale)

  return (
    <div className="main-navigation__subnav custom-fast-dropdown nav-options-dropdown">
      <div className="custom-fast-dropdown__inner">
        <div
          className="custom-fast-dropdown__top nav-options-dropdown__section nav-options-dropdown__section--highlighted"
        >
          <p className="cgt-legacy-text-caption nav-options-dropdown__title">
              {earnWithCgtraderTitle}
          </p>
          <a
            className="cgt-menu-item cgt-menu-item--medium cgt-menu-item--icon-left"
            href="/3d-modeling-jobs/browse"
            data-track-label="For Designers"
            data-track-text="Freelance on CGTrader"
          >
            <span className="cgt-menu-item__lead-icon">
              <div className="cgt-icon cgt-icon__icon cgt-icon--default">
                <img src={cgLogo} alt="CGTrader logo" loading="lazy" height="24" width="24" />
              </div>
            </span>
            <span className="cgt-menu-item__text">
              {freelanceOnCgtrader}
            </span>
          </a>
          <a
            className="cgt-menu-item cgt-menu-item--medium cgt-menu-item--icon-left"
            href="https://wildcat.cgtrader.com/"
            data-track-label="For Designers"
            data-track-text="Work on Modelry"
          >
            <span className="cgt-menu-item__lead-icon">
              <div className="cgt-icon cgt-icon__icon cgt-icon--default">
                <img src={moLogo} alt="Modelry logo" loading="lazy" height="24" width="24" />
              </div>
            </span>
            <span className="cgt-menu-item__text">
              {workOnModelry}
            </span>
          </a>
        </div>

        <div className="custom-fast-dropdown__middle nav-options-dropdown__section">
          <p className="cgt-legacy-text-caption nav-options-dropdown__title">
            {growYourSalesTitle}
          </p>
          <ul className="main-navigation__subnav-group">
            {salesLinks.map(({ title, href, trackLabel, trackText }) => (
                <li key={title} className="user-menu-item">
                  <a
                    className="cgt-menu-item cgt-menu-item--medium"
                    href={href}
                    data-track-label={trackLabel}
                    data-track-text={trackText}
                  >
                    {title}
                  </a>
                </li>
              ))}
          </ul>
        </div>

        <div className="custom-fast-dropdown__bottom nav-options-dropdown__section">
          <p className="cgt-legacy-text-caption nav-options-dropdown__title">
            {communityTitle}
          </p>
          <ul className="main-navigation__subnav-group">
            {communityLinks.map(({ href, trackText, title: linkText, badge }, i) => (
              <li
                key={i}
                className="user-menu-item"
              >
                <a
                  className="cgt-menu-item cgt-menu-item--medium"
                  href={href}
                  data-track-label="For Designers"
                  data-track-text={trackText}
                >
                  {linkText}
                  {badge && (
                    <Badge
                      className={`community-dropdown__badge community-dropdown__badge--${badge.type}`}
                    >
                      {badge.text}
                    </Badge>
                  )}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  )
}

CommunityDropdown.propTypes = {
  communityLinks: arrayOf(shape({
    href: string,
    trackText: string,
    title: string,
    badge: shape({
      text: string,
      type: string,
    }),
  })),
  locale: string,
}

export default CommunityDropdown
